import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Plus, Search } from "lucide-react";
import { ListLayout } from "@/components/custom/list-layout/list-layout";
import { Loader } from "@/components/custom/loader";

// The shell (header, description, add action, search) matches the loaded list so
// it stays put when data resolves. The body is a generic loader because the loaded
// page can be an empty state or a table depending on what's published.
export const CatalogListSkeleton = () => (
  <ListLayout
    actions={
      <Button disabled size="sm">
        <Plus className="mr-2 size-4" />
        Add grant
      </Button>
    }
    description="Publish which tools each IdP group — or everyone — can self-serve."
    filters={
      <div className="flex items-center gap-3">
        <div className="relative max-w-md">
          <Search className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            className="h-9 w-full pl-9"
            disabled
            placeholder="Search end-user tools..."
          />
        </div>
      </div>
    }
    title="End-user dashboard"
  >
    <output className="flex min-h-[360px] w-full items-center justify-center rounded-lg border border-border/60 bg-background/35">
      <Loader />
      <span className="sr-only">Loading end-user tools</span>
    </output>
  </ListLayout>
);
